import {
  ColumnHeightOutlined,
  VerticalAlignMiddleOutlined
} from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useAreaTreeStore } from '../Store/hooks'

export const ToggleExpandAllAreaTreeButton = () => {
  const { isExpanded, toggleExpandAll } = useAreaTreeStore(state =>
    pick(state, ['isExpanded', 'toggleExpandAll'])
  )
  const expanded = isExpanded()

  return (
    <Tooltip title={expanded ? '全部折叠' : '展开所有'}>
      <Button
        type='text'
        icon={
          expanded ? <VerticalAlignMiddleOutlined /> : <ColumnHeightOutlined />
        }
        onClick={() => toggleExpandAll()}
      />
    </Tooltip>
  )
}
